<template>
  <!-- <img :src="faceSrc" @error="onError($event)" /> -->
  <img style="height:100%" :src="faceSrc" @error="onError($event)" />
</template>
<script>
export default {
  props: {
    UserID: String,
    CnName: String,
    defalutImg: String
  },
  computed: {
    faceSrc() {
      let { UserID } = this;
      let curUserID = this.$store.state.core.user.userid;
      let _id = UserID || curUserID;
      return this.$store.state.core.getFacebyUserID(_id);
    }
  },
  data() {
    return {};
  },
  methods: {
    onError($event) {
      if (this.defalutImg) {
        event.target.src = this.defalutImg;
      }
    }
  }
};
</script>